<mat-selection-list #matSelection role="list" class="list-plantillas" (selectionChange)="getSelected($event)">
  <mat-list-option *ngFor="let item of plantillasNominaList" [value]="item">
    {{ item.IdPlantillaNomina + ' - ' + item.NplantillaNomina }}
  </mat-list-option>
</mat-selection-list>